module.exports = __webpack_public_path__ + "static/media/cctv.1b640be7.svg";